import { render, staticRenderFns } from "./DeclineAffiliationModal.vue?vue&type=template&id=9854e43a&scoped=true&"
import script from "./DeclineAffiliationModal.vue?vue&type=script&lang=js&"
export * from "./DeclineAffiliationModal.vue?vue&type=script&lang=js&"
import style0 from "./DeclineAffiliationModal.vue?vue&type=style&index=0&id=9854e43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9854e43a",
  null
  
)

component.options.__file = "DeclineAffiliationModal.vue"
export default component.exports